var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.image.breakPoints
    ? _c(
        "picture",
        { staticClass: "v-picture" },
        [
          _vm._l(_vm.image.breakPoints, function (img, index) {
            return [
              img.hasOwnProperty("webp")
                ? _c("v-picture-source", {
                    key: "imageWebP-" + index,
                    attrs: {
                      value: img,
                      "media-prop": index,
                      "type-image": "image/webp",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("v-picture-source", {
                key: "imageMain-" + index,
                attrs: { value: img, "media-prop": index },
              }),
              _vm._v(" "),
              _c("img", {
                key: "imageSource-" + index,
                class: _vm.addClass,
                attrs: { src: _vm.mainSrc, alt: _vm.alt, title: _vm.title },
              }),
            ]
          }),
        ],
        2
      )
    : _c("img", {
        class: _vm.addClass,
        attrs: { src: _vm.mainSrc, alt: _vm.alt, title: _vm.title },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }